import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';

function CsvDataSlider({ attachment }) {
    const [csvData, setCsvData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchCsvData() {
            const fileExtension = attachment.split('.').pop().toLowerCase();

            if (fileExtension === 'csv') {
                try {
                    const response = await fetch(attachment);
                    if (!response.ok) {
                        throw new Error(`Fetch error: ${response.statusText}`);
                    }
                    const text = await response.text();

                    Papa.parse(text, {
                        header: true,
                        skipEmptyLines: true,
                        complete: (results) => {
                            setCsvData({
                                headers: Object.keys(results.data[0] || {}),
                                data: results.data
                            });
                            setLoading(false);
                        },
                        error: (err) => {
                            setError(err.message);
                            setLoading(false);
                        }
                    });
                } catch (err) {
                    setError(err.message);
                    setLoading(false);
                }
            } else {
                setCsvData(null);
                setLoading(false);
            }
        }

        fetchCsvData();
    }, [attachment]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!csvData) {
        return <div>No CSV data available</div>;
    }

    return (
        <div style={{
            width: "100%"
        }}>
        <div className="csv-viewer-slider">
            <table>
                <thead>
                    <tr>
                        {csvData.headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {csvData.data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {csvData.headers.map((header, colIndex) => (
                                <td key={colIndex}>{row[header]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
            </div>
    );
}

export default CsvDataSlider;
